module.exports = __webpack_public_path__ + "img/4.dc64991d.png";